export default {
  bookingSchedule: [],
  bookingScheduleFilter: {}
};
